export default __webpack_public_path__ + "fbd56f5b2d81b46179d7356c478ee67c.gif";